import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import './form-item-payspace-payroll-and-hr-v2.component.scss';
var FormItemPayspacePayrollAndHrV2 = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemPayspacePayrollAndHrV2, _super);
    function FormItemPayspacePayrollAndHrV2(element) {
        return _super.call(this, element) || this;
    }
    FormItemPayspacePayrollAndHrV2.prototype.init = function () {
        this.form = this.element.querySelector('form');
        this.submitBtn = this.element.querySelector('.js-payspace-payroll-and-hr__button');
        this.contactNumber = this.element.querySelector('input[name=contact-number]');
        this.firstName = this.form.querySelector("input[name=first-name]");
        this.lastName = this.form.querySelector("input[name=last-name]");
        this.firstName.setAttribute('maxlength', '60');
        this.lastName.setAttribute('maxlength', '60');
        // display views
        if (this.form) {
            this.displayLoader = this.form.querySelector(".form-container__loader");
            this.displayFields = this.form.querySelector(".form-container__fields");
            this.displaySuccess = this.form.querySelector(".form-container__success");
            this.displayError = this.form.querySelector('.form-container__error');
        }
        //Privacy 
        this.showMoreBtn = this.element.querySelector('.data-privacy-collapse-show');
        this.showLessBtn = this.element.querySelector('.data-privacy-collapse-hide');
        this.dataPrivacyDetailArea = this.element.querySelector('.data-privacy-detail');
        this.dataSharingGroupHideBtn = this.element.querySelector('.data-sharing-group-hide-btn');
        this.dataSharingGroupShowBtn = this.element.querySelector('.data-sharing-group-show-btn');
        this.dataSharingGroupTextArea = this.element.querySelector('.data-sharing-group');
        this.dataSharing3rdPartyShowBtn = this.element.querySelector('.data-sharing-3rd-party-show-btn');
        this.dataSharing3rdPartyHideBtn = this.element.querySelector('.data-sharing-3rd-party-hide-btn');
        this.dataSharing3rdPartyTextArea = this.element.querySelector('.data-sharing-3rd-party');
        this.dataSharingBoardersHideBtn = this.element.querySelector('.data-sharing-boarders-hide-btn');
        this.dataSharingBoardersShowBtn = this.element.querySelector('.data-sharing-boarders-show-btn');
        this.dataSharingBoardersTextArea = this.element.querySelector('.data-sharing-boarders');
    };
    FormItemPayspacePayrollAndHrV2.prototype.bindEvents = function () {
        var _this = this;
        this.contactNumber.addEventListener("input", function () {
            this.value = this.value.replace(/[e\+\-\,]/gi, "");
        });
        this.submitBtn.addEventListener('click', function (event) {
            var _button = event.target;
            var _form = _button.closest('form');
            var formFields = _form.querySelectorAll('input, select');
            formFields = Array.from(formFields).filter(function (item) { return item['name'] !== 'registrationnumber'; });
            _this.validationService.validate(formFields);
            var valid = Array.from(_form.querySelectorAll('.form__group--error'));
            //const _isValid = this.validateFormStepRadios();
            if (valid.length === 0) {
                _this.submitForm(_form);
            }
        });
        this.showLessBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.showLessBtn.setAttribute('hidden', 'true');
            _this.showMoreBtn.removeAttribute('hidden');
            _this.dataPrivacyDetailArea.setAttribute('hidden', 'true');
        });
        this.showMoreBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.showMoreBtn.setAttribute('hidden', 'true');
            _this.showLessBtn.removeAttribute('hidden');
            _this.dataPrivacyDetailArea.removeAttribute('hidden');
        });
        this.dataSharingGroupHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingGroupTextArea.setAttribute('hidden', 'true');
            _this.dataSharingGroupHideBtn.setAttribute('hidden', 'true');
            _this.dataSharingGroupShowBtn.removeAttribute('hidden');
        });
        this.dataSharingGroupShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingGroupTextArea.removeAttribute('hidden');
            _this.dataSharingGroupHideBtn.removeAttribute('hidden');
            _this.dataSharingGroupShowBtn.setAttribute('hidden', 'true');
        });
        this.dataSharing3rdPartyHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharing3rdPartyTextArea.setAttribute('hidden', 'true');
            _this.dataSharing3rdPartyShowBtn.removeAttribute('hidden');
            _this.dataSharing3rdPartyHideBtn.setAttribute('hidden', 'true');
        });
        this.dataSharing3rdPartyShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharing3rdPartyTextArea.removeAttribute('hidden');
            _this.dataSharing3rdPartyHideBtn.removeAttribute('hidden');
            _this.dataSharing3rdPartyShowBtn.setAttribute('hidden', 'true');
        });
        this.dataSharingBoardersShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingBoardersTextArea.removeAttribute('hidden');
            _this.dataSharingBoardersShowBtn.setAttribute('hidden', 'true');
            _this.dataSharingBoardersHideBtn.removeAttribute('hidden');
        });
        this.dataSharingBoardersHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingBoardersTextArea.setAttribute('hidden', 'true');
            _this.dataSharingBoardersHideBtn.setAttribute('hidden', 'true');
            _this.dataSharingBoardersShowBtn.removeAttribute('hidden');
        });
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll('input, select, textarea'));
            if (_formFields) {
                _formFields.forEach(function (pEement) {
                    pEement.addEventListener('blur', function (pEvent) {
                        if (pEvent.target['name'] !== 'registrationnumber') {
                            _this.validationService.validateBlur(pEvent.currentTarget);
                        }
                    });
                });
            }
        }
        var payrollsystem = Array.from(this.form.querySelectorAll("input[name='payrollsystem']"));
        var numberofemployees = this.form.getElementsByClassName("numberofemployees")[0];
        var Frequencies = this.form.getElementsByClassName('frequencies')[0];
        payrollsystem.map(function (item) { return item.addEventListener("click", function (event) {
            var evt = event.target;
            var value = evt.value;
            if (value === 'NO') {
                numberofemployees.classList.add('hidden');
                Frequencies.classList.add('hidden');
            }
            else if (value === 'YES') {
                numberofemployees.classList.remove('hidden');
                Frequencies.classList.remove('hidden');
            }
        }); });
        // Reset the form
        this.form.addEventListener("custom_form_reset_event", function (pEvent) {
            _this.showDisplayView("");
        }, false);
    };
    FormItemPayspacePayrollAndHrV2.prototype.validateFormStepRadios = function () {
        var _this = this;
        var allRadiosInStepSelector = "input[type=radio]";
        var _radios = Array.from(this.form.querySelectorAll(allRadiosInStepSelector));
        var tracker = new Map();
        var isStepValid = true;
        _radios.forEach(function (radio) {
            var radios;
            if (!tracker.get(radio.name)) {
                radios = new Array();
                radios.push(radio);
                tracker.set(radio.name, radios);
            }
            else {
                radios = tracker.get(radio.name);
                radios.push(radio);
            }
        });
        Array.from(tracker.keys()).forEach(function (key) {
            var _targetRadios = tracker.get(key);
            var isValid = false;
            var targetElement = null;
            _targetRadios.forEach(function (r) {
                targetElement = r;
                if (targetElement.checked) {
                    isValid = true;
                }
            });
            _this.removeError(targetElement);
            if (!isValid) {
                _this.addError(targetElement, null);
                isStepValid = false;
            }
        });
        return isStepValid;
    };
    FormItemPayspacePayrollAndHrV2.prototype.addError = function (field, errorMessage) {
        var fieldErrorDetail = errorMessage;
        if (!fieldErrorDetail) {
            fieldErrorDetail = "This field is required";
        }
        var containingDiv = field.closest(".form__group");
        containingDiv.classList.add("form__group--error");
        var _errorDiv = document.createElement("div");
        _errorDiv.classList.add("form__group--error_message");
        var _errors = document.createElement("ul");
        _errorDiv = document.createElement("div");
        _errorDiv.classList.add("form__group--error_message");
        var _error = document.createElement("li");
        _error.innerHTML = fieldErrorDetail;
        _errors.appendChild(_error);
        _errorDiv.appendChild(_errors);
        containingDiv.appendChild(_errorDiv);
    };
    FormItemPayspacePayrollAndHrV2.prototype.removeError = function (field) {
        var containingDiv = field.closest(".form__group");
        if (containingDiv.classList.contains("form__group--error")) {
            containingDiv.classList.remove("form__group--error");
            containingDiv.removeChild(containingDiv.lastChild);
            return true;
        }
        return false;
    };
    FormItemPayspacePayrollAndHrV2.prototype.submitForm = function (pForm) {
        var _this = this;
        var _firstname = this.form.querySelector("input[name=first-name]");
        var _lastName = this.form.querySelector("input[name=last-name]");
        var _companyname = this.form.querySelector("input[name=companyname]");
        var _industry = this.form.querySelector("input[name=industry]");
        var _registrationnumber = this.form.querySelector("input[name=registrationnumber]");
        var _payrollsystem = this.form.querySelector("input[name=payrollsystem]");
        var _numberofemployees = this.form.querySelector("input[name=numberofemployees]");
        var _frequencies = this.form.querySelector("input[name=frequencies]");
        var _contact = this.form.querySelector("input[name=contact-number]");
        var _emailAddress = this.form.querySelector("input[name=emailAddress]");
        var _product = this.form.querySelector('input[name=product]');
        var email = this.form.querySelector("input[name=email]");
        var recipient = this.form.querySelector("input[name=recipient]");
        var subject = this.form.querySelector("input[name=subject]");
        // fields
        var popiaConsent = this.form.querySelector("input[name=popia-consent]");
        var _postData = {
            'recipient': (recipient ? recipient.value : ""),
            'subject': (subject ? subject.value : ""),
            'email': (email ? email.value : ""),
            'product': (_product ? _product.value : ''),
            'emailAddress': (_emailAddress ? _emailAddress.value : ""),
            'firstName': (_firstname ? _firstname.value : ""),
            'lastName': (_lastName ? _lastName.value : ""),
            'contactNo': (_contact ? _contact.value : ""),
            'companyName': (_companyname ? _companyname.value : ""),
            'industry': (_industry ? _industry.value : ""),
            'businessRegistration': (_registrationnumber ? _registrationnumber.value : ""),
            'payrollSystem': (_payrollsystem ? _payrollsystem.value : ""),
            'numberOfEmployees': (_numberofemployees ? _numberofemployees.value : ""),
            'frequencies': (_frequencies ? _frequencies.value : ""),
            'dataPrivacyConsent': ((popiaConsent ? (popiaConsent.checked ? "YES" : "NO") : "NO")),
            'dataSharingGroup': this.getDataConsentValue(this.form, 'data-sharing-group'),
            'dataSharing3rdParty': this.getDataConsentValue(this.form, 'data-sharing-3rd-party'),
            'dataSharingBoarders': this.getDataConsentValue(this.form, 'data-sharing-boarders')
        };
        this.showDisplayView("loader");
        // variables
        var url = this.baseUrl + "/bcleadUtils/payroll-lead";
        // config
        var _config = {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        // service
        this.formsService.postForm(url, _postData, _config).then(function (pResponse) {
            _this.analyticsService.dtmFormComplete("complete", pResponse.code);
            _this.showDisplayView("success");
        }).catch(function (pError) {
            // service failed
            _this.analyticsService.dtmRecordSiteError("noerrorcode|service failure occured|" + url);
            _this.showDisplayView("error");
        });
    };
    FormItemPayspacePayrollAndHrV2.prototype.getDataConsentValue = function (form, selector) {
        var radioBtn = form.querySelector("input[name=\"" + selector + "\"]:checked");
        if (radioBtn && radioBtn.checked) {
            return radioBtn.value.toUpperCase();
        }
        else {
            return null;
        }
    };
    FormItemPayspacePayrollAndHrV2.prototype.showDisplayView = function (pDisplay) {
        this.displayLoader.classList.add("hidden");
        this.displayFields.classList.add("hidden");
        this.displaySuccess.classList.add("hidden");
        this.displayError.classList.add("hidden");
        switch (pDisplay) {
            case "success":
                this.displaySuccess.classList.remove("hidden");
                break;
            case "error":
                this.displayError.classList.remove("hidden");
                break;
            case "loader":
                this.displayLoader.classList.remove("hidden");
                break;
            default:
                this.displayFields.classList.remove("hidden");
                break;
        }
    };
    return FormItemPayspacePayrollAndHrV2;
}(Base));
export { FormItemPayspacePayrollAndHrV2 };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-payspace-payroll-and-hr-v2/form-item-payspace-payroll-and-hr-v2.component.ts
// module id = 1031
// module chunks = 0